import React from "react";

import AccountantWorkspace from "../AccountDashboard/AccountantWorkspace";

export default function AccountsRouting({ role, user, onLogout }) {
  return (
    <div className="prod-module-root">
      <AccountantWorkspace user={user} onLogout={onLogout} />
    </div>
  );
}
